import { Wrench, Settings, SearchCheck, Droplets, Gauge, ArrowUpRight } from "lucide-react";

const icons = [Wrench, Settings, SearchCheck, Droplets, Gauge];

export const Services = ({ t }) => {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="bg-white py-24 md:py-32"
    >
      <div className="mx-auto max-w-7xl px-6 md:px-12">
        <div className="grid grid-cols-1 gap-12 md:grid-cols-12">
          <div className="md:col-span-5">
            <div className="mb-4 text-xs font-semibold uppercase tracking-[0.25em] text-green-600">
              {t.services.label}
            </div>
            <h2 className="font-display text-3xl font-bold leading-tight tracking-tight text-neutral-950 sm:text-4xl lg:text-5xl">
              {t.services.title}
            </h2>
            <p className="mt-5 max-w-md text-base leading-relaxed text-neutral-600">
              {t.services.subtitle}
            </p>
          </div>

          <div className="md:col-span-7">
            <div className="divide-y divide-neutral-200 border-y border-neutral-200">
              {t.services.list.map((s, i) => {
                const Icon = icons[i] || Wrench;
                return (
                  <div
                    key={i}
                    data-testid={`service-item-${i}`}
                    className="group flex items-start gap-6 py-6 transition-colors duration-200 hover:bg-neutral-50"
                  >
                    <div className="flex h-12 w-12 shrink-0 items-center justify-center border border-neutral-900 bg-neutral-950 text-white transition-colors duration-200 group-hover:bg-green-600 group-hover:border-green-600">
                      <Icon size={20} />
                    </div>
                    <div className="flex-1">
                      <div className="flex items-start justify-between gap-4">
                        <h3 className="font-display text-xl font-bold tracking-tight text-neutral-950">
                          {s.title}
                        </h3>
                        <div className="mt-1 text-[10px] font-semibold uppercase tracking-[0.2em] text-neutral-400">
                          0{i + 1}
                        </div>
                      </div>
                      <p className="mt-2 max-w-lg text-sm leading-relaxed text-neutral-600">
                        {s.desc}
                      </p>
                    </div>
                    <ArrowUpRight
                      size={18}
                      className="mt-2 shrink-0 text-neutral-300 transition-all duration-200 group-hover:-translate-y-0.5 group-hover:translate-x-0.5 group-hover:text-green-600"
                    />
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
